import { useOperationsStore } from '@operations/AppProvider'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { appStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'

interface Props {
  open: boolean
  workQueueId?: number | null
  onClose: () => void
  onConfirm: () => void
}
export const StopWorkQueueDialog = observer(({ open, workQueueId, onClose, onConfirm }: Props) => {
  const { t } = useTranslate()
  const { workQueueStore } = useOperationsStore()

  const handleStop = async () => {
    if (workQueueId) await workQueueStore.stopWorkQueue(workQueueId)

    onConfirm()
    appStore.setShowAlert('success', t('workQueueStopped', 'Work queue stopped successfully'))
  }

  return (
    <ConfirmationDialog
      open={open}
      title={t('stopWorkQueue', 'Stop work queue?')}
      maxWidth='xs'
      message={t(
        'stopWorkQueueMessage',
        'Stopping the selected working queue will remove the jobs from the operator devices. It won’t reflect jobs that are in progress or done.',
      )}
      primaryActionText={t('yesStop', 'Yes, stop')}
      primaryActionDataCy='crane-split-stop-work-queue-confirm-btn'
      closeLabel={t('cancel', 'Cancel')}
      onClose={onClose}
      onConfirm={handleStop}
    />
  )
})
